import { useMemo } from "react";
import { useAppStore } from "../../stores";
import {
  DOMAIN_OPTIONS,
  filterDomainOptionsByPrivileges,
  type DomainOption,
} from "./constants";

/**
 * Domain dropdown options gated by `gri.regulation.view_*` privileges.
 * Until privileges load, returns the full list so the current Select value
 * remains valid (avoids MUI out-of-range warnings on cold start).
 */
export function useAllowedDomainOptions(): {
  options: DomainOption[];
  privilegesLoaded: boolean;
} {
  const privileges = useAppStore((state) => state.ui?.privileges) ?? [];
  const privilegesLoaded =
    useAppStore((state) => state.ui?.privilegesLoaded) ?? false;

  const options = useMemo(() => {
    if (!privilegesLoaded) return DOMAIN_OPTIONS;
    return filterDomainOptionsByPrivileges(privileges);
  }, [privileges, privilegesLoaded]);

  return { options, privilegesLoaded };
}
